var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocationwhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 119,
    viewBox: "0 0 96 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.9112 65.2029C57.2494 65.2029 64.8195 57.6328 64.8195 48.2946C64.8195 38.9564 57.2494 31.3863 47.9112 31.3863C38.573 31.3863 31.0029 38.9564 31.0029 48.2946C31.0029 57.6328 38.573 65.2029 47.9112 65.2029Z",
    stroke: "#ECECEC",
    strokeWidth: 5.63609,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.911 3.20581C35.9527 3.20581 24.4842 7.95622 16.0285 16.412C7.57267 24.8678 2.82227 36.3363 2.82227 48.2946C2.82227 58.958 5.08797 65.9355 11.2764 73.657L47.911 115.928L84.5456 73.657C90.734 65.9355 92.9998 58.958 92.9998 48.2946C92.9998 36.3363 88.2494 24.8678 79.7936 16.412C71.3378 7.95622 59.8693 3.20581 47.911 3.20581V3.20581Z",
    stroke: "#ECECEC",
    strokeWidth: 5.63609,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationwhite);
export default __webpack_public_path__ + "static/media/locationwhite.2de1ad0c9b6c1be5817d574efe96f76d.svg";
export { ForwardRef as ReactComponent };